module.exports = __webpack_public_path__ + "static/media/notiIcon.7c575c31.svg";